import React, {  ReactNode, useEffect, useRef, useState } from 'react';
import { useOktaAuth } from '@okta/okta-react'

import { IOktaUser } from 'interfaces';
import { UserService } from 'services';
import { Accordion, AccordionItem, Avatar, Icon, Logo, NavLink, SideNavigation, SideNavigationContent, Tooltip } from '@cfa/react-components';
import { Desktop } from '@cfa/brand-icons';
import { NavLink as ReactRouterNavLink } from 'react-router-dom';

export function Sidebar() {
    const { oktaAuth, authState } = useOktaAuth();
    const [user, setUser] = useState<IOktaUser>();

    // Load or clear our user info when the user logs in/out.
    // We'll keep track of whether the user was previously authenticated when we rendered last.
    const prevIsAuthedRef = useRef(false);
    useEffect(() => {
        if (!prevIsAuthedRef.current && authState.isAuthenticated) {
            // If the user has just now been authenticated, we need to load their info the the navbar.
            oktaAuth.token.getUserInfo()
                .then((loadedUser: IOktaUser) => {
                    setUser(loadedUser);
                })
                .catch((err) => {
                    console.log('ERROR fetching user: ', err);
                });
        } else if (prevIsAuthedRef.current && !authState.isAuthenticated) {
            // If the user was authenticated and has just now been logged out, clear our user info.
            setUser(undefined);
        }

        prevIsAuthedRef.current = authState.isAuthenticated;
    }, [authState]);

    const signout = () => {
        UserService.reset();
        oktaAuth.signOut();
    }

    const avatarSignout: ReactNode = (<>
        {user && (<>
            <Tooltip
                content={user.name}
                placement='bottom-end'
                showOnElementEvents={[
                    'hover'
                ]}
            >
                <Avatar name={user.name} />
            </Tooltip>
        </>)}
    </>);

    const sidebar = (
        <SideNavigation>
            <SideNavigationContent
                section="start"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: '16px',
                }}
            >
                <Logo logo="symbolInCircle" size="md" />
            </ SideNavigationContent>
            <SideNavigationContent
                section="middle"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <NavLink
                    to="/devices"
                    as={ReactRouterNavLink}
                    icon={<Icon icon={Desktop} />}
                >
                    Devices
                </NavLink>
            </ SideNavigationContent>
            <SideNavigationContent
                section="end"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                {user && (<>
                    <Accordion
                        iconPosition="end"
                        variant="default"
                        style={{ marginBottom: 4, marginTop: 32 }}
                    >
                        <AccordionItem header={avatarSignout} itemKey="0">
                            <NavLink onClick={signout} variant="sidenavigation-link">
                                Log Out
                            </NavLink>
                        </AccordionItem>
                    </Accordion>

                </>)}
            </SideNavigationContent>


        </SideNavigation>
    );
    if(user){
        return sidebar
    }

    return <div></div>
}
